import { API_ENDPOINTS } from 'Constants/env';
import { ContactModelV2, IContact as IContactV2 } from 'Models/ContactModelV2';
import { useNotificationStore } from 'Modules/notification/store';
import { bugsnagClient } from 'Utils/logUtils';
import API from '../api';

export const searchPersonBySip = async (
  sip: string
): Promise<ContactModelV2 | null> => {
  try {
    const results = await API.get<{ data?: IContactV2 }>(
      API_ENDPOINTS.SipSearch(),
      {
        params: { sip, sourcePlatform: 'Bhive' },
      }
    );
    return ContactModelV2.fromResponseDto(results.data.data);
  } catch (error) {
    if (error?.response?.status !== 404) {
      useNotificationStore.getState().addNotify({
        type: 'error',
        dismissible: true,
        title: 'Error starting the call',
        message: 'The call wasn’t started. Please try again.',
      });

      bugsnagClient.notify('Error Searching Person by SIP', (event) => {
        event.severity = 'error';
        event.context = 'SearchStore';
        event.addMetadata('custom', { function: 'searchPersonBySip' });
      });
    }
    return null;
  }
};
